import { partialReplacer } from '@shared/Frontend/utils/updaters'
import { AsyncState, Maybe } from 'ballerina-core'
import { Actions } from '../shared/actions/actions.state'
import { CMSImage } from '../shared/cmsImage/cmsImage.state'
import { BlocksState } from './blocks/blocks.state'
import { FiltersState, initialFiltersState } from './filters/filters.state'
import { initialTeasersAsync, TeasersAsync } from './teasers/teasers.state'
import { TeaserState } from './teasers/teasers.template'

export type CMSPageState = AsyncState<Maybe<CMSPage>>

export type CMSPage = {
  metaTitle?: string
  header: CMSPageHeader
  slug: string
  locale: string
  breadcrumbs: Array<{ url: string; title: string }>
  localizationLinks?: LocalizationLinks
} & (
  | ({ teasers: TeaserState; filters: FiltersState } & (
      | { kind: 'news overview' | 'person overview' | 'standpoints overview' | 'ourview overview'}
      | { kind: 'search'; searchQuery: string }
    ))
  | (BlocksState &
      (
        | { kind: 'generic' | 'home' | 'about' | 'contact' | 'cookies' | 'terms' | 'privacy' }
        | { kind: 'news'; categories: Array<Category> }
        | { kind: 'standpoints'; }
        | { kind: 'ourview'; }
        | {
            kind: 'person'
            name: string
            email?: string
            function?: string
            website?: string
            phoneNumber?: string
            image?: CMSImage
            socialLinks: Array<SocialLink>
          }
      ))
)

export type Category = { uuid: string; id: number; name: string; group: string }

export type CMSPageHeader = { title?: string; introduction?: string; image?: CMSImage, publicationDate?: Date } & Actions

export type LocalizationLinks = { [key: string]: { slug: string; id: number } }

export type SocialLink = { url: string; type: SocialLinkPlatform }
export type SocialLinkPlatform = 'Twitter' | 'Instagram' | 'Facebook' | 'LinkedIn' | 'Website'

export const initialCMSPageState = (previousCMSPageStateWithSameSlug?: CMSPageState): CMSPageState =>
  previousCMSPageStateWithSameSlug === undefined
    ? AsyncState.Default.unloaded()
    : previousCMSPageStateWithSameSlug.map(
        Maybe.Operations.map(
          (value): CMSPage =>
            value.kind === 'news overview' || value.kind === 'person overview' || value.kind === 'standpoints overview' || value.kind === 'ourview overview' || value.kind === 'search'
              ? partialReplacer({
                  filters: initialFiltersState(value.filters),
                  teasers: {
                    items: initialTeasersAsync(value.teasers.items)
                  },
                })(value)
              : value
        )
      )
